import {
  Box,
  Divider,
  IconButton,
  Tooltip,
  Grid2 as Grid,
  Collapse,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TemplateAdvancedConfig, {
  type FormData,
} from "./template-advanced-config";
import type {
  AvailableValidCharacterItem,
  ValidCharacterItem,
} from "../types/api-types";

interface TemplateAdvancedSectionProps {
  showAdvancedConfig: boolean;
  onToggleAdvanced: () => void;
  templateId: number;
  formData: FormData;
  availableValidCharacters: AvailableValidCharacterItem[];
  isLoadingValidCharacters: boolean;
  onFormDataChange: React.Dispatch<React.SetStateAction<FormData>>;
  onSaveValidCharacters: (
    added: ValidCharacterItem[],
    deleted: ValidCharacterItem[],
  ) => Promise<void>;
}

const TemplateAdvancedSection = ({
  showAdvancedConfig,
  onToggleAdvanced,
  templateId,
  formData,
  availableValidCharacters,
  isLoadingValidCharacters,
  onFormDataChange,
  onSaveValidCharacters,
}: TemplateAdvancedSectionProps) => {
  return (
    <>
      <Grid size={12}>
        <Box
          sx={{
            position: "relative",
            mt: 4,
            mb: 2,
          }}
        >
          <Divider />
          <Tooltip title="Advanced Configuration" arrow>
            <IconButton
              onClick={onToggleAdvanced}
              size="small"
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: showAdvancedConfig
                  ? "translate(-50%, -50%) rotate(180deg)"
                  : "translate(-50%, -50%) rotate(0deg)",
                transition: "transform 0.3s",
                bgcolor: "background.paper",
                border: 1,
                borderColor: "divider",
                "&:hover": {
                  bgcolor: "grey.100",
                  borderColor: "primary.main",
                },
              }}
            >
              <ExpandMoreIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      </Grid>

      <Grid size={12}>
        <Collapse in={showAdvancedConfig} timeout="auto" unmountOnExit>
          <TemplateAdvancedConfig
            templateId={templateId}
            formData={formData}
            availableValidCharacters={availableValidCharacters}
            isLoadingValidCharacters={isLoadingValidCharacters}
            setFormData={onFormDataChange}
            onSaveValidCharacters={onSaveValidCharacters}
          />
        </Collapse>
      </Grid>
    </>
  );
};

export default TemplateAdvancedSection;
